module.exports = __webpack_public_path__ + "static/media/quadra.530a5101.jpg";